let baseFrontendUrl;
baseFrontendUrl = "http://ahrishya,surgipharma.onrender.com";
// baseUrl = "https://api-drunkenbytes.onrender.com/api"

export default baseFrontendUrl;